import { FC, ReactElement, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { ITeamMemberMapped } from '~/utils/clientAllocation';
import { AllocationMode } from '../../constants/allocationMode';
import { useAddClientAllocationContext } from '../context/AddClientAllocationContext';
import AllocationClientsList from './AllocationsList/AllocationClientsList';
import AllocationClientsListGU from './AllocationsList/AllocationClientsListGU';
import AllocationLocationGroupsList from './AllocationsList/AllocationLocationGroupsList';
import { IAddAllocationFormValues } from '../types';

interface IProps {
  teamMemberIdx: number;
  teamMember: ITeamMemberMapped;
}

const AssignedClients: FC<IProps> = ({ teamMemberIdx, teamMember }): ReactElement => {
  const { allocationMode, currentUserRole } = useAddClientAllocationContext();
  const { setValue } = useFormContext<IAddAllocationFormValues>();

  useEffect(() => {
    const isAllocationModeClient = allocationMode === AllocationMode.BY_CLIENT;
    if (isAllocationModeClient) {
      setValue(`teamMembersAllocations.${teamMemberIdx}.locationGroupAllocations`, []);
      setValue(`teamMembersAllocations.${teamMemberIdx}.selectedLocationGroupIds`, []);
      return;
    }
    setValue(`teamMembersAllocations.${teamMemberIdx}.clientsAllocations`, []);
    setValue(`teamMembersAllocations.${teamMemberIdx}.selectedClientsIds`, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allocationMode, teamMemberIdx]);

  if (allocationMode === AllocationMode.BY_LOCATION_GROUP) {
    return <AllocationLocationGroupsList teamMemberIdx={teamMemberIdx} teamMember={teamMember} />;
  }

  if (currentUserRole.isGlobalUser) {
    return <AllocationClientsListGU teamMemberIdx={teamMemberIdx} teamMember={teamMember} />;
  }

  return <AllocationClientsList teamMemberIdx={teamMemberIdx} teamMember={teamMember} />;
};

export default AssignedClients;
